import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyComplaint = createAsyncThunk(
  "societyComplaint",
  async ({ status, startDate, endDate, societyId }) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.get(
        `${API_KEY}/api/complain/filter`,

        {
          headers: {
            Authorization: `Barear ${token}`,
          },
          params: {
            ...(status && { status }),
            ...(startDate && endDate && { startDate, endDate }),
            ...(societyId && { societyId }),
          },
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  societyComplaintData: null,
  isError: false,
  errorMessage: "",
};
const societyComplaintSlice = createSlice({
  name: "societyComplaint",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyComplaint.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyComplaint.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyComplaintData = action.payload;
    });
    builder.addCase(societyComplaint.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyComplaintSlice.reducer;
